import { useEffect, useState } from "react";

// Stato che sopravvive al ritorno sulla pagina (sessione del browser).
export function useSticky(key, init) {
  const [v, setV] = useState(() => {
    try { const s = sessionStorage.getItem(`sticky_${key}`); return s != null ? JSON.parse(s) : init; } catch { return init; }
  });
  useEffect(() => { sessionStorage.setItem(`sticky_${key}`, JSON.stringify(v)); }, [key, v]);
  return [v, setV];
}
